export { ReactComponent as EmbedObject } from './svgs/embed-object.svg';
